export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Id',
    },
    cell: {
      type: 'text',
      value: (e) => e.id,
    },
  },
  {
    width: 13,
    header: {
      type: 'text',
      caption: 'Influence',
    },
    cell: {
      type: 'slot',
      name: 'influence',
    },
  },
  {
    width: 20,
    header: {
      type: 'text',
      caption: 'Comment',
    },
    cell: {
      type: 'text',
      value: (e) => e.comment,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Receiver',
    },
    cell: {
      type: 'slot',
      name: 'receiver',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Sender',
    },
    cell: {
      type: 'slot',
      name: 'sender',
    },
  },
  {
    width: 40,
    header: {
      type: 'text',
      caption: 'Date Created',
      sort: 'createdAt',
    },
    cell: {
      type: 'slot',
      name: 'createdAt',
    },
  },
];
